import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  linearProgressBarUniDriverFactory,
  LinearProgressBarUniDriver,
} from '../internal/WixUiCoreComponents/components/CoreLinearProgressBar/CoreLinearProgressBar.uni.driver';

export interface ProgressBarDriver extends LinearProgressBarUniDriver {}

export const progressBarDriverFactory = (
  base: UniDriver,
): ProgressBarDriver => {
  return {
    ...linearProgressBarUniDriverFactory(base),
  };
};
